import classNames from 'classnames'

import Button, { BUTTON_HEIGHT_32 } from '../../Button'

import { getEntityTabSubTabDefaultItemLabel } from './EntityTabSubTabs.utils'

import * as styles from './EntityTabSubTabs.module.css'

function EntityTabSubTabs({
  activeValue,
  className = styles.EntityTabSubTabs,
  getItemLabel = getEntityTabSubTabDefaultItemLabel,
  getItemQaName,
  height = BUTTON_HEIGHT_32,
  items,
  renderItem,
  onChange,
}) {
  function getHandleClick(value) {
    return () => onChange(value)
  }

  return (
    <div className={className}>
      {items.map(item => {
        const isActive = item.value === activeValue

        return (
          <Button.Outlined
            isGrey
            className={classNames(styles.item, {
              [styles.itemActive]: isActive,
            })}
            height={height}
            isActive={isActive}
            key={item.value}
            qaName={getItemQaName?.(item)}
            text={renderItem ? undefined : getItemLabel(item)}
            onClick={getHandleClick(item.value)}
          >
            {renderItem?.(item)}
          </Button.Outlined>
        )
      })}
    </div>
  )
}

export default EntityTabSubTabs
